import React from "react";
import { CheckCircle2 } from "lucide-react";

/**
 * SuccessCard — premium success confirmation shown in-place of a form.
 * MAD TURBO branding: dark card, neon green icon, Barlow Condensed title.
 */
export default function SuccessCard({ title, body, testid }) {
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid={testid}
      className="card-mt card-mt-pad !p-8 md:!p-12 flex flex-col items-start fade-in-up"
      style={{ borderColor: "rgba(163,230,53,0.45)" }}
    >
      <div
        className="icon-tile mb-6 animate-pulse-glow"
        style={{ width: "3.25rem", height: "3.25rem" }}
      >
        <CheckCircle2 size={22} />
      </div>
      <h3 className="h-display text-3xl md:text-4xl text-white mb-3 leading-tight">
        {title}
      </h3>
      <p className="text-zinc-300 leading-relaxed max-w-lg whitespace-pre-line">
        {body}
      </p>
    </div>
  );
}
